module.exports = __webpack_public_path__ + "img/15.9cb21606.jpg";